import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const ClassifiersIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        id="Vector 116"
        d="M15.81 16.9C15.99 16.9 16.16 16.97 16.31 17.07C16.6 17.27 16.82 17.61 16.82 17.95C16.82 18.47 16.31 19 15.81 19C15.31 19 2 19 1.75 19C1.5 19 1 18.39 1 17.95C1 17.51 1.5 16.9 1.75 16.9C2 16.9 15.31 16.9 15.81 16.9ZM1 17.95C1 17.95 1 3.09 1 2.25C1 1.41 1 1 1.75 1C2.5 1 15.56 1 16.31 1C17.07 1 17.07 1.62 17.07 1.62C17.07 1.62 17.07 15.44 17.07 16.06C17.07 16.69 16.31 17.07 16.31 17.07"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
      />
      <path
        id="Vector 117"
        d="M4.71 2C4.71 1.71 4.49 1.5 4.21 1.5C3.93 1.5 3.71 1.71 3.71 2L3.71 3.71C3.71 3.99 3.93 4.21 4.21 4.21C4.49 4.21 4.71 3.99 4.71 3.71L4.71 2ZM4.71 5C4.71 4.71 4.49 4.5 4.21 4.5C3.93 4.5 3.71 4.71 3.71 5L3.71 17L4.71 17L4.71 5ZM17.92 13.26C17.63 13.36 17.35 13.44 17.06 13.51L17.29 14.48C17.61 14.41 17.93 14.31 18.25 14.2C18.55 14.09 18.79 13.99 18.97 13.88C19.32 13.67 19.5 13.43 19.5 13.14L19.5 3.28Q19.5 3.2 19.48 3.13Q19.4 2.79 18.97 2.54Q18.7 2.38 18.26 2.22C17.94 2.11 17.62 2.01 17.29 1.94L17.29 1.94L17.06 2.91L17.06 2.91L17.06 2.91C17.35 2.98 17.64 3.06 17.92 3.16C18.16 3.25 18.33 3.32 18.46 3.4C18.47 3.41 18.48 3.41 18.5 3.42L18.5 6.42L17.18 6.42L17.18 7.42L18.5 7.42L18.5 9.53L17.18 9.53L17.18 10.53L18.5 10.53L18.5 13C18.48 13.01 18.47 13.01 18.46 13.02C18.33 13.09 18.15 13.17 17.92 13.26Z"
        fill="#FFFFFF"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
      <path
        id="Vector 118"
        d="M2.05 15L3.11 15M3.11 12.75L2.05 12.75M3.11 8.87L2.05 8.87M3.11 5.62L2.05 5.62M3.11 3L2.05 3"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        strokeLinecap="round"
      />
      <path
        id="Vector 93"
        d="M12.83 12C12.83 12 14 12 14 10.68C14 9.37 14 7.47 14 6.3C14 5.13 12.25 5.01 11.66 5C11.07 4.99 9.87 5 9.33 5C8.79 5 7 5.06 7 6.3C7 7.54 7 9.37 7 10.68C7 12 8.16 12 8.16 12L12.83 12Z"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="0.800000"
      />
      <path
        id="Vector 96"
        d="M13.5 12L15 12.99M7.5 12L6 12.99M8 13L13 13"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="0.800000"
        strokeLinecap="round"
      />
      <path
        id="Vector 94"
        d="M9 6L12 6"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="0.800000"
        strokeLinecap="round"
      />
      <circle
        id="Ellipse 20"
        cx="8.500000"
        cy="10.500000"
        r="0.500000"
        fill="#FFFFFF"
        fillOpacity="1.000000"
      />
      <circle
        id="Ellipse 20"
        cx="8.500000"
        cy="10.500000"
        r="0.100000"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="0.800000"
      />
      <circle
        id="Ellipse 21"
        cx="12.500000"
        cy="10.500000"
        r="0.500000"
        fill="#FFFFFF"
        fillOpacity="1.000000"
      />
      <circle
        id="Ellipse 21"
        cx="12.500000"
        cy="10.500000"
        r="0.100000"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="0.800000"
      />
      <path
        id="Vector 95"
        d="M7 9L14 9M7 7L14 7"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="0.800000"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};
